var React = require('react');

function Love (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0-1h16v16H0z","key":0}),React.createElement("path",{"fill":"#087bcc","fillRule":"nonzero","d":"M14.682 1.318A4.485 4.485 0 0 0 11.5 0 4.377 4.377 0 0 0 8 1.707 4.383 4.383 0 0 0 4.5 0a4.5 4.5 0 0 0-3.182 7.682L8 14l6.682-6.318a4.5 4.5 0 0 0 0-6.364zm-1.4 4.933L8 11.247l-5.285-5A2.5 2.5 0 0 1 4.5 2c1.437 0 2.312.681 3.5 2.625C9.187 2.681 10.062 2 11.5 2a2.5 2.5 0 0 1 1.785 4.251h-.003z","key":1})]));
}

Love.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = Love;

Love.default = Love;
